import React from "react";
import { useNavigate } from "react-router-dom";
import PulseStrip from "@/components/PulseStrip";

const BG = "https://images.unsplash.com/photo-1551807041-07fb850f64b3?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80";

export default function AgeGate() {
  const nav = useNavigate();

  const confirm = () => {
    localStorage.setItem("nw_age_ok", "yes");
    nav("/enter");
  };

  return (
    <div className="min-h-screen w-full relative overflow-hidden dark" data-theme="dark" data-testid="age-gate" style={{ backgroundColor: "#050505", color: "#F4F4F0" }}>
      <div
        className="absolute inset-0 bg-cover bg-center grayscale"
        style={{ backgroundImage: `url(${BG})`, filter: "grayscale(100%) brightness(0.35)" }}
      />
      <div className="absolute inset-0 bg-obsidian/80" />
      <div className="relative z-10 min-h-screen flex flex-col">
        <header className="p-6 md:p-10 flex justify-between items-center border-b border-white/10">
          <div className="font-mono text-xs text-acid tracking-widest">// NW.SYSTEM v1.0</div>
          <div className="font-mono text-xs text-white/60 tracking-widest">SESSION: NEW</div>
        </header>

        <main className="flex-1 flex flex-col items-center justify-center px-6 text-center">
          <div className="font-mono text-blaze text-xs md:text-sm tracking-[0.4em] mb-6 border border-blaze px-4 py-1">
            [ LIVE · ALWAYS ON ]
          </div>
          <h1
            className="font-heading text-6xl md:text-8xl lg:text-9xl leading-none text-paper"
            data-testid="age-gate-title"
          >
            NITE<span className="text-acid">WIRE</span>
          </h1>
          <p className="mt-4 font-mono text-white/70 text-xs md:text-sm tracking-widest">
            &gt; ALWAYS-LIVE ROOMS · DIALOGUE ONLY · NO SCRIPTS
          </p>

          <div className="mt-10 max-w-lg font-body text-white/80 text-sm md:text-base leading-relaxed">
            A live chat forum built for real conversation. Rooms are always open —
            romance, business, gossip, mundane thursdays. Pick a handle and walk in.
          </div>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <button className="btn-acid" data-testid="age-gate-confirm" onClick={confirm}>
              ENTER THE WIRE
            </button>
          </div>

          <div className="mt-12 w-full">
            <PulseStrip />
          </div>

          <div className="divider-ascii mt-16 text-xs">// // // // // // // // // // // // // // //</div>
        </main>

        <footer className="p-6 md:p-10 font-mono text-[10px] md:text-xs text-white/40 flex justify-between border-t border-white/10">
          <span>BE KIND · NO ILLEGAL CONTENT · REPORT BUTTON IN EVERY ROOM</span>
          <span>NW//2026</span>
        </footer>
      </div>
    </div>
  );
}
